import { getActiveToken } from '@/composables/useCurrentUserData'

export function authorizationData () {
    return 'Bearer ' + getActiveToken()
}
